module.exports = function(value) {
	return value.replace(/[-_]/g, " ")
};



// WEBPACK FOOTER //
// ./app/statamic/resources/js/filters/deslugify.js